/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-07 10:21:15
 * @LastEditors: caiqin.xie
 * @message: 门店-banner组件
 */
import React from "react";
import styles from "../../index.module.scss";
import { Carousel } from '@arco-design/web-react';
import VideoDialog from "@/components/VideoDialog";
import { useDevice } from '@/hooks'
import LazyMedia from "@/components/LazyMedia";
import { IBanner } from "@/common/types";

interface IProps {
  bannerList: IBanner[];
  words: Record<string, string>;
}

const Banner = (props:IProps) => {
  const { words, bannerList} = props
  const device = useDevice()
  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)
  const [isShowVideo, setIsShowVideo] = React.useState(false); // 是否播放视频
  const [currentVideoUrl, setCurrentVideoUrl] = React.useState(''); // 当前视频地址
  // 播放视频
  const watchVideo = (videoUrl: string) => {
    setCurrentVideoUrl(videoUrl)
    setIsShowVideo(true)
  }
  return (
    <>
      {bannerList && bannerList.length > 0 && (
        <Carousel autoPlay  className={styles["banner-wrap"]}>
          {bannerList.map((item, index) => {
            return (
              <div key={index}>
                  {
                    item[newDevice].extension === '.mp4'
                    ? <LazyMedia LazyClassName='full-wh' type="video" loop autoPlay preload="auto" playsInline muted src={item[newDevice]?.url}></LazyMedia>
                    : <LazyMedia LazyClassName='full-wh' type="image" src={item[newDevice]?.url} alt={item[newDevice]?.alt} />
                  }
                <div className={styles["banner-content"]}>
                  <div className={styles["banner-content"]}>
                    {item?.isShowTitle === 1 && (
                      <h1 className={styles["banner-title"]}>{item?.name}</h1>
                    )}
                    <p className={styles["banner-sub-title"]}>{item?.briefIntroduction}</p>
                    {
                      (item[newDevice].extension === '.mp4'
                      ? <span className={styles["learn-more-white"]} onClick={() => watchVideo(item[newDevice]?.url)}>{words?.shop_banner_watch_now}</span>
                      : '')
                    }
                    {/* Watch Now */}
                  </div>
                </div>
              </div>
            )
          })}
        </Carousel>
      )}
      {isShowVideo && <VideoDialog words={words} videoUrl={currentVideoUrl} setIsShowVideo={setIsShowVideo} />}
    </>

  )
}
export default Banner
